module.exports = __webpack_public_path__ + "static/media/orpheus_pro.21b9184b.otf";